"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
var _default = {
  props: {
    tip: {
      type: String,
      default: '用户时长分布的数据计算至当前日期前一天，非实时更新'
    },
    text: {
      type: String,
      default: '数据更新说明'
    }
  }
};
exports.default = _default;